import styles from "./home.module.css";
import { FaTelegramPlane } from "react-icons/fa";
import { AiOutlineInstagram } from "react-icons/ai";
import { BsTwitter } from "react-icons/bs";
function Footer() {
  return (
    <div className={` ${styles.footConainer}`}>
      <div
        className={`d-flex container  justify-content-around   flex-wrap ${styles.footConainers}`}
      >
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot}`}>
          <div>
            <p className={styles.textHeadFoot}>تات کلاب</p>
            <div className={styles.divider}></div>
          </div>
          <p className={styles.textAFoot}>
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است،{" "}
          </p>
        </div>
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot}`}>
          <div>
            <p className={styles.textHeadFoot}> پشتیبانی تات کلاب</p>
            <div className={styles.divider}></div>
          </div>

          <a className={styles.textAFoot}>تماس با ما</a>
          <a className={styles.textAFoot}>قوانین مقررات</a>
          <a className={styles.textAFoot}>سوالات متداول</a>
        </div>
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot}`}>
          <div>
            <p className={styles.textHeadFoot}>لینک های سریع</p>
            <div className={styles.divider}></div>
          </div>

          <a className={styles.textAFoot}>سوالات متداول</a>
          <a className={styles.textAFoot}>انتقادات و پیشنهادات</a>
          <a className={styles.textAFoot}>قوانین و مقررات</a>
          <a className={styles.textAFoot}> حریم ‌خصوصی</a>
        </div>
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot}`}>
          <div>
            <p className={styles.textHeadFoot}>راهنمای خرید از تات کلاب</p>
            <div className={styles.divider}></div>
          </div>

          <a className={styles.textAFoot}>نحوه ثبت سفارش</a>
          <a className={styles.textAFoot}>رویه ارسال سفارش</a>
          <a className={styles.textAFoot}>شیوه های پرداخت</a>
        </div>
        <div
          className={` d-flex pt-4 flex-column text-center ${styles.widthFootTelegram}`}
        >
          <p className={styles.textPFoot}>ما را در فضای مجازی دنبال کنید</p>
          <div className="d-flex justify-content-center">
            <div className={styles.telegramDiv}>
              <FaTelegramPlane className={styles.telegramIcon} />
            </div>
            <div className={styles.telegramDiv}>
              <AiOutlineInstagram className={styles.telegramIcon} />
            </div>
            <div className={styles.telegramDiv}>
              <BsTwitter className={styles.telegramIcon} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
